<div class="tw-gap-4 tw-flex tw-flex-col">
  <!-- Header -->
  <div
    class="tw-flex tw-items-start tw-p-6 sm:tw-p-4 tw-gap-4 sm:tw-flex-col sm:tw-gap-3 tw-rounded-xl tw-bg-color-surface-card tw-shadow-elevation-card"
  >
    <span
      class="transaction-form-label tw-text-color-status-info-text !tw-border !tw-border-solid !tw-border-color-status-info-border tw-bg-color-status-info-bg !tw-font-bold tw-uppercase tw-tracking-wide"
      >Align.</span
    >
    <div class="tw-flex tw-flex-col tw-gap-1 tw-flex-grow">
      <span class="tw-text-2xl sm:tw-text-xl tw-text-color-text-default tw-font-semibold">
        Statement Balance Details
      </span>
      <span class="tw-text-sm tw-text-color-text-secondary tw-leading-5">
        The balance as of a given date — retrieved from your bank or entered manually — used to
        verify and reconcile records.
      </span>
    </div>
  </div>

  <!-- BALANCE RECORD section -->
  <div
    class="tw-bg-color-surface-card tw-shadow-elevation-card tw-rounded-xl tw-px-6 tw-pt-5 tw-pb-2 sm:tw-px-4"
  >
    <div class="tw-flex tw-flex-col tw-divide-y tw-divide-color-border-subtle">
      <!-- TYPE row -->
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-8 sm:tw-gap-3 tw-py-3">
        <div class="tw-flex tw-items-center tw-gap-8 sm:tw-gap-3">
          <label
            class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-color-text-secondary tw-w-16 tw-shrink-0"
          >
            {{ "type" | i18n }}
          </label>
          <span class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
            data().balanceType
          }}</span>
        </div>
        @if (canEdit()) {
          <button
            type="button"
            class="tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-bg-color-surface-card tw-border tw-border-primary tw-w-10 tw-h-10 tw-rounded-lg tw-shadow-icon-edit tw-aspect-square tw-shrink-0 -tw-my-2.5"
            [attr.aria-label]="'edit' | i18n"
            (click)="openEditBalance()"
          >
            <icon [size]="6" [name]="'edit'" [currentColor]="'primary'"></icon>
          </button>
        }
      </div>

      <!-- BALANCE row -->
      <div class="tw-flex tw-items-center tw-gap-8 sm:tw-gap-3 tw-py-3">
        <label
          class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-color-text-secondary tw-w-16 tw-shrink-0"
        >
          {{ "balance" | i18n }}
        </label>
        <div class="tw-flex tw-items-baseline tw-gap-1.5">
          <span class="tw-text-sm tw-text-color-text-secondary">{{ data().symbol }}</span>
          <span
            class="tw-font-D-DIN-PRO tw-tabular-nums tw-text-xl tw-font-semibold"
            [ngClass]="{
              'tw-text-color-money-in-text': data().balance > 0.01,
              'tw-text-color-text-secondary': data().balance >= -0.01 && data().balance <= 0.01,
              'tw-text-dt-text-out-primary': data().balance < -0.01,
            }"
            >{{ data().balance | number: "1.0-2" }}</span
          >
        </div>
      </div>

      <!-- DATE row -->
      <div class="tw-flex tw-items-center tw-gap-8 sm:tw-gap-3 tw-py-3">
        <label
          class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-color-text-secondary tw-w-16 tw-shrink-0"
        >
          {{ "date" | i18n }}
        </label>
        <span class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
          data().date | date: "d MMM yyyy"
        }}</span>
      </div>

      <!-- NOTE row -->
      <div class="tw-flex tw-items-center tw-gap-8 sm:tw-gap-3 tw-py-3">
        <label
          class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-color-text-secondary tw-w-16 tw-shrink-0"
        >
          {{ "note" | i18n }}
        </label>
        <span class="tw-text-sm tw-font-medium tw-text-color-text-secondary">{{
          data().description || "-"
        }}</span>
      </div>

      <!-- SOURCE row -->
      <div class="tw-flex tw-items-center tw-gap-8 sm:tw-gap-3 tw-py-3">
        <label
          class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-color-text-secondary tw-w-16 tw-shrink-0"
        >
          {{ "source" | i18n }}
        </label>
        <div
          class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-[3px] tw-bg-color-money-in-bg tw-border tw-border-color-money-in-border tw-rounded-full"
        >
          <span class="tw-w-2 tw-h-2 tw-rounded-full tw-shrink-0 tw-bg-color-money-in"></span>
          <span class="tw-text-sm tw-font-medium tw-text-color-text-default">{{
            data().source
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
